export default {
  data: () => ({
    mainPage: null,
    subPage: null
  }),
  methods: {
    enter () {
      this.mainPage = document.querySelector('.main-page')
      this.subPage = document.querySelector('.sub-page')
      this.subPage.classList.add('fixed')
    },
    afterEnter () {
      this.mainPage.classList.add('none')
      this.subPage.classList.remove('fixed')
      scrollTo(0, 0)
    },
    beforeLeave () {
      this.mainPage = document.querySelector('.main-page')
      // enter時に取得出来なかった場合のために必要
      this.mainPage.classList.remove('none')
      this.subPage.classList.add('fixed')
    },
    afterLeave () {
      this.subPage.classList.remove('fixed')
    }
  },
  mounted () {
    this.mainPage = document.querySelector('.main-page')
    this.subPage = document.querySelector('.sub-page')
    if (this.subPage) {
      this.afterEnter()
    }
  },
  template: `
<transition name="slide"
  @enter="enter"
  @after-enter="afterEnter"
  @before-leave="beforeLeave"
  @after-leave="afterLeave"
>
  <slot></slot>
</transition>
`
}



// WEBPACK FOOTER //
// ./src/components/sub-page-container.js